// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function accessTokenInterceptor(config: any): any {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
}
